import React from 'react';
import PropTypes from 'prop-types';

export default function IconSearch24({ className }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.14645 4.14645C4.34171 3.95118 4.65829 3.95118 4.85355 4.14645L19.8536 19.1464C20.0488 19.3417 20.0488 19.6583 19.8536 19.8536C19.6583 20.0488 19.3417 20.0488 19.1464 19.8536L4.14645 4.85355C3.95118 4.65829 3.95118 4.34171 4.14645 4.14645Z"
        fill="#1F1F1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8536 4.14645C20.0488 4.34171 20.0488 4.65829 19.8536 4.85355L4.85355 19.8536C4.65829 20.0488 4.34171 20.0488 4.14645 19.8536C3.95118 19.6583 3.95118 19.3417 4.14645 19.1464L19.1464 4.14645C19.3417 3.95118 19.6583 3.95118 19.8536 4.14645Z"
        fill="#1F1F1F"
      />
    </svg>
  );
}

IconSearch24.propTypes = {
  className: PropTypes.string,
};

IconSearch24.defaultProps = {
  className: '',
};
